const listeners = new Map();
export const appEvents = {
    on: (event, handler) => {
        const handlers = listeners.get(event) ?? new Set();
        handlers.add(handler);
        listeners.set(event, handlers);
    },
    off: (event, handler) => {
        const handlers = listeners.get(event);
        if (!handlers)
            return;
        handlers.delete(handler);
        if (handlers.size === 0) {
            listeners.delete(event);
        }
    },
    emit: (event, payload) => {
        const handlers = listeners.get(event);
        if (!handlers?.size)
            return;
        handlers.forEach((handler) => {
            handler(payload);
        });
    },
};
